<template>
  <v-select
    ref="select"
    :value="value"
    :items="filteredItems"
    :menu-props="{
      'content-class': 'snt-menu',
      'origin': 'center center',
      'transition':'slide-y-transition',
      'nudge-top': '-4px',
      'maxHeight': 320,
      'offset-y': true,
    }"
    :placeholder="placeholder"
    height="37px"
    width="248px"
    item-text="text"
    item-value="value"
    hide-details
    outlined
    dense
    v-on="$listeners">
    <template #selection="{ item }">
      <div class="d-flex align-center">
        <v-icon
          :style="{
            backgroundColor: item.option.color
          }"
          class="snt-select__icon-bank"
          color="#ffffff"
          size="22"
          left>
          $bank_{{ item.option.value }}
        </v-icon>
        <span :class="`text-overflow--1`">{{ item.text }}</span>
      </div>
    </template>
    <template #item="{ item }">
      <div class="d-flex align-center">
        <v-icon
          :style="{
            backgroundColor: item.option.color
          }"
          class="snt-select__icon-bank"
          color="#ffffff"
          size="22"
          left>
          $bank_{{ item.option.value }}
        </v-icon>
        <span :class="`text-overflow--1`">{{ item.text }}</span>
      </div>
    </template>
  </v-select>
</template>

<script>
import banks from '@/resources/json/banks'

export default {
  props: {
    value: {
      type: [String, Array, Number, Boolean, Object],
      default: ''
    },
    items: {
      type: Array,
      default: () => ([])
    },
    placeholder: {
      type: String,
      default: undefined
    }
  },
  computed: {
    filteredItems  () {
      return this.items.map((item) => ({
        text: item.text,
        value: item.value,
        option: banks.find((bank) => bank.value === item.bank)
      }))
    }
  },
  mounted () {
    this.$refs.select.lastItem = 1000
  }
}
</script>
<style>
  .snt-menu {
    padding: 8px 4px;
    background: white;
    overflow-y: hidden;
  }
</style>
<style lang="scss" scoped>
  ::v-deep {
    .v-icon svg {
      fill: currentColor;
    }
  }
  .snt-select {
    &__icon-bank {
      padding: 2px;
      border-radius: 100%;
    }
    ::v-deep {
      .v-input--is-focused {
        fieldset {
          border: 1px solid currentColor;
        }
      }
      .v-select__selections {
        line-height: inherit;
      }
      .v-input__control > .v-input__slot {
        min-height: 37px !important;
      }
      .v-input__icon--clear .v-icon {
        font-size: 1rem;
      }
    }
  }
  .snt-menu.v-menu__content {
    > .v-select-list {
      &.v-list {
        padding: 0 4px;
        ::v-deep {
          overflow-y: auto;
          max-height: 304px;
          .v-list-item {
            margin-bottom: 4px;
            border-radius: 4px;
            &::before {
              border-radius: 4px;
            }
            &:hover::before {
              opacity: 0.1;
            }
            &.v-list-item--link:hover {
              color: var(--v-primary-base) !important;
            }
            .v-list-item__title {
              font-size: 1rem !important;
              font-style: normal;
              font-weight: normal;
              line-height: 24px;
            }
          }
        }
      }
    }
  }
</style>
